<template>
    <div class="wrap" v-show="scoreInfo.deduct_state === '1'">
        抵扣{{scoreData.score ? scoreData.score : 0}}积分 <span class="price">-¥{{scoreData.deductPrice.toFixed(2)}}</span>&nbsp;&nbsp;
        <el-popover
                v-model="popState"
                placement="top"
                transition=""
                width="400"
                trigger="click">
            <el-button type="text" slot="reference">修改抵扣</el-button>
            <div class="score-wrap">
                <h3>修改抵扣</h3>
                <el-row class="row">
                    <el-col :span="8" class="tr">可用积分:&nbsp;&nbsp;</el-col>
                    <el-col :span="16">{{scoreInfo.score}}</el-col>
                </el-row>
                <br/>
                <el-row class="row" v-if="isAllow">
                    <el-col :span="8" class="tr">积分抵扣:&nbsp;&nbsp;</el-col>
                    <el-col :span="16">
                        <el-input v-model="form.score" class="score-input" size="mini"
                                  @keypress.native="e => {if(e.charCode === 13) submit();}"
                                  ref="scoreInput"
                        /> &nbsp;分 = {{form.deductPrice}}元
                    </el-col>
                </el-row>
                <el-row class="row" v-else>
                    <el-col :span="4" class="tr">&nbsp;&nbsp;</el-col>
                    <el-col :span="20" class="price">
                        <i class="el-icon-remove icon-size"></i> 大于等于{{scoreInfo.deduct_min_score}}积分才可抵现
                    </el-col>
                </el-row>
                <br/>
                <el-row>
                    <el-col :span="24" class="tr">
                        <el-button size="medium" @click="close">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>
                        <el-button size="medium" type="primary" @click="submit">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-popover>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "CashUseScore",
        model: {
            prop: "scoreData",
            event: "scoreChange"
        },
        props: {
            scoreData: {
                type: Object,
                default: () => ({
                    score: 0,
                    deductPrice: 0
                }),
            },
            totalPrice: {
                type: Number,
                default: 0
            },
            storeUid: {
                type: [String, Number],
                default: 0
            }
        },
        data: () => ({
            form: {
                score: 0,
                deductPrice: "0.00"
            },
            scoreInfo: {
                deduct_min_score: "0",
                deduct_rate: "0",
                deduct_state: "0",
                score: "0",
            },
            popState: false,
            isAllow: true,      //是否允许抵扣
        }),
        methods: {
            getStoreUserScore: function () {
                return new Promise((resolve, reject) => {
                    if(obj.isEmpty(this.storeUid)) {
                        this.scoreInfo = {
                            deduct_min_score: "0",
                            deduct_rate: "0",
                            deduct_state: "0",
                            score: "0",
                        };
                        resolve();
                    }

                    this.$root.postData("cash/get_score_deduct_info", {store_uid: this.storeUid}, res => {
                        if(res.errcode === 0) {
                            this.scoreInfo = res.data;
                            resolve();
                        }else{
                            reject(res.errdesc);
                        }
                    });
                });
            },
            close: function () {
                this.popState = false;
            },
            submit: function () {
                let minScore = parseFloat(this.scoreInfo.deduct_min_score);
                let surScore = parseFloat(this.scoreInfo.score);

                if(obj.isEmpty(this.scoreInfo.deduct_state)) {
                    this.$root.error("积分抵扣未开启");
                    return false;
                }

                if(!obj.isEmpty(this.form.score)) {
                    if (!obj.isEmpty(minScore) && minScore > surScore) {
                        this.$root.error("大于等于" + minScore + "积分才可抵现");
                        return false;
                    }

                    if (this.form.score < minScore) {
                        this.$root.error("最低使用" + minScore + "积分才可抵现");
                        return false;
                    }

                    if (parseFloat(this.form.score) > surScore) {
                        obj.message.error("积分不足");
                        return false;
                    }

                    if (parseFloat(this.form.deductPrice) > this.totalPrice) {
                        obj.message.error("积分抵扣金额不能超过订单金额");
                        return false;
                    }
                }

                let scoreData = {
                    score: this.form.score ? parseFloat(this.form.score) : 0,
                    deductPrice: parseFloat(this.form.deductPrice)
                };
                this.$emit("scoreChange", scoreData);
                this.close();
            }
        },
        watch: {
            scoreData: function (val) {
                this.form.score = val.score;
            },
            storeUid: function (val) {
                this.getStoreUserScore();
            },
            "form.score": function (val) {
                let score = val ? val : 0;
                if(!obj.isEmpty(this.scoreInfo.deduct_rate)) {
                    this.form.deductPrice = (score / this.scoreInfo.deduct_rate).toFixed(2);
                }
            },
            popState: function (val) {
                if(val) {
                    this.getStoreUserScore().then(res => {
                        if(this.scoreInfo.deduct_min_score > this.scoreInfo.score) {
                            this.isAllow = false;
                        }else {
                            this.isAllow = true;

                            this.form.score = this.scoreData.score;
                            this.$nextTick( () => {
                                this.$refs["scoreInput"].select();
                                this.$refs["scoreInput"].focus();
                            });
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .wrap{
        background-color: #f7f8fa;
        text-align: right;
        padding: 0px 16px;
    }
    .price{
        color: red;
    }
    .score-input{
        width: 80px;
    }
    .row{
        line-height: 30px;
    }
    .icon-size{
        font-size: 16px;
    }
</style>
